import React from 'react';
import { Link } from 'react-router-dom';
import BlobImage from 'components/blobImage';
import { Copy, Modal, SystemText } from '@salesperformanceint/e4shared';
import FileLink from 'components/general/fileLink';
import Assets, { extension } from 'components/general/assets';
import Rating from 'components/general/rating';
import { e4Format, e4Formats } from 'helpers/dates';

export const TaskRejectionSection = props => {
    const [display, setDisplay] = React.useState(0);

    const move = direction => {
        const { task } = props;
        let tempDisplay = display;
        tempDisplay += direction;
        if (tempDisplay < 0) tempDisplay = task.rejections.length - 1;
        if (tempDisplay >= task.rejections.length) tempDisplay = 0;
        setDisplay(tempDisplay);
    };

    const { show, close, task, profile } = props;

    if (!task.rejections || task.rejections.length === 0) return null;

    const rejection = task.rejections[display];
    const viewing = e4Format(rejection.date_Rejected, null, true);

    const shareComments = task.share_Comments.filter(c => c.rejection_Id === rejection.id);
    const hasCompetencies = rejection.competencies && rejection.competencies.length > 0;

    const text = {
        othersComments: SystemText('Objective/Rejection/OthersComments'),
        previousAttempts: {
            label: SystemText('Objective/Rejection/PreviousAttempts'),
            attempt: SystemText('Objective/Rejection/PreviousAttempts/Attempt'),
            prev: SystemText('Objective/Rejection/PreviousAttempts/Prev'),
            next: SystemText('Objective/Rejection/PreviousAttempts/Next'),
        },
        details: SystemText('Objective/Rejection/Details'),
        feedback: {
            label: SystemText('Objective/Rejection/Feedback'),
            worked: SystemText('Objective/Rejection/Feedback/Worked'),
            didnt: SystemText('Objective/Rejection/Feedback/Didnt'),
            missing: SystemText('Objective/Rejection/Feedback/Missing'),
        },
        ratings: SystemText('Objective/Rejection/Ratings'),
    };

    const btnHidden = task.rejections.length === 1 ? 'hidden' : 'btn btn-sm btn-primary mr10';

    const commentsSection =
        shareComments.length > 0 ? (
            <div className="col-md-12 mt10">
                <div className="form-group">
                    <label>{text.othersComments}</label>
                    {shareComments.map((comment, i) => (
                        <div className="user-comment" key={`comment-${i}`}>
                            <div>
                                <Link to={`/search/${comment.owner_Full_Name}`}>
                                    <BlobImage
                                        folder="avatar"
                                        initials={comment.owner_Initials}
                                        alt={comment.owner_Full_Name}
                                        src={comment.owner_Avatar}
                                        key={comment.owner_Avatar}
                                    />
                                </Link>
                            </div>
                            <div>
                                <Link to={`/search/${comment.owner_Full_Name}`}>{comment.owner_Full_Name}</Link>
                                <div>{e4Format(comment.date_Added, null, true)}</div>
                                <div className="mb10">
                                    <Copy value={comment.comment} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        ) : null;

    return (
        <Modal show={show} title={text.previousAttempts.label} close={close} footer={null}>
            <div className="row">
                <div className="col-md-12 mb10">
                    <label>{text.previousAttempts.attempt}</label>
                    <div>
                        <button
                            className={btnHidden}
                            title={text.previousAttempts.prev}
                            data-testid="button-rejections-prev"
                            disabled={display === 0}
                            onClick={() => move(-1)}
                        >
                            <i className="fa fa-arrow-left" />
                        </button>
                        <span className="mr10">{viewing}</span>
                        <button
                            className={btnHidden}
                            title={text.previousAttempts.next}
                            data-testid="button-rejections-next"
                            disabled={display === task.rejections.length - 1}
                            onClick={() => move(1)}
                        >
                            <i className="fa fa-arrow-right" />
                        </button>
                    </div>
                </div>
                <div>
                    <div className="col-md-12">
                        <label>{text.details}</label>
                        <div className="user-comment">
                            <div>
                                <Link to={`/search/${profile?.full_Name}`}>
                                    <BlobImage
                                        folder="avatar"
                                        initials={profile?.initials}
                                        alt={profile?.full_Name}
                                        src={profile?.avatar}
                                        key={profile?.avatar}
                                    />
                                </Link>
                            </div>
                            <div>
                                {rejection.completed_Video_Asset && (
                                    <FileLink
                                        folder="task_Completion"
                                        file={{
                                            ...task.completed_Video_Asset,
                                            video: true,
                                            ext: extension(rejection.completed_Video_Asset),
                                        }}
                                    />
                                )}
                                {rejection.comments && (
                                    <div className="mt10">
                                        <Copy value={rejection.comments} />
                                    </div>
                                )}
                                {rejection.completed_Assets && (
                                    <div className="mt10">
                                        <Assets assets={rejection.completed_Assets} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 mt10">
                        <label>{text.feedback.label}</label>
                        <div className="user-comment">
                            <div>
                                <Link to={`/search/${rejection.feedback_Full_Name}`}>
                                    <BlobImage
                                        folder="avatar"
                                        initials={rejection.feedback_From_Initials}
                                        alt={rejection.feedback_Full_Name}
                                        key={rejection.feedback_From_Avatar}
                                        src={rejection.feedback_From_Avatar}
                                    />
                                </Link>
                            </div>
                            <div>
                                <div>
                                    <label>{text.feedback.worked}</label>
                                    <div className="mb10">
                                        {rejection.feedback_1 ? <Copy value={rejection.feedback_1} /> : '-'}
                                    </div>
                                </div>
                                <div>
                                    <label>{text.feedback.didnt}</label>
                                    <div className="mb10">
                                        {rejection.feedback_2 ? <Copy value={rejection.feedback_2} /> : '-'}
                                    </div>
                                </div>
                                <div>
                                    <label>{text.feedback.missing}</label>
                                    <div className="mb10">
                                        {rejection.feedback_3 ? <Copy value={rejection.feedback_3} /> : '-'}
                                    </div>
                                </div>
                                <div>
                                    {hasCompetencies ? (
                                        <div>
                                            <label>{text.ratings}</label>
                                            {rejection.competencies.map(c => {
                                                return (
                                                    <div key={`rating-${c.id}`} className="flex flex-row">
                                                        <div className="mr10 ">{`${c.area} - ${c.name}`}</div>
                                                        <Rating hideLabel smallStar value={c.rating} />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <Rating value={rejection.rating} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    {commentsSection}
                </div>
            </div>
        </Modal>
    );
};

export default TaskRejectionSection;
